import httpClient from "../utils/httpClient";

export const getCountry = async () => {
    const response = await httpClient.get(`/Country/GetCountry`);
    return response.data;
};

export const getStateByCountryId = async (requestParams) => {
    const response = await httpClient.post('/Country/get-state', requestParams);
    return response.data;
};